export enum DistributionStatus {
    TO_BE_CHECKED,
    CAN_BE_CHECKED,
    CHECKED,
    UNKNOWN,
}
